import { EMPTY_VALUE_PLACEHOLDER } from "./core";

const timeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: "2-digit",
  minute: "2-digit",
});

const shortDateFormatter = new Intl.DateTimeFormat(undefined, {
  day: "2-digit",
  month: "2-digit",
});

const dateTimeShortFormatter = new Intl.DateTimeFormat(undefined, {
  day: "2-digit",
  month: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

/**
 * Helper privado para validar e converter a data.
 */
function getValidDate(date: Date | string | number | null): Date | null {
  if (!date) return null;

  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return null;
  }

  return d;
}

/**
 * Formata para HH:mm (Ex: 12:45)
 */
export function formatTime(date: Date | string | number | null): string {
  const validDate = getValidDate(date);
  if (!validDate) {
    return EMPTY_VALUE_PLACEHOLDER;
  }

  return timeFormatter.format(validDate);
}

/**
 * Formata para DD/MM (Ex: 16/12)
 */
export function formatDateShort(date: Date | string | number | null): string {
  const validDate = getValidDate(date);
  if (!validDate) {
    return EMPTY_VALUE_PLACEHOLDER;
  }

  return shortDateFormatter.format(validDate);
}

/**
 * Formata para DD/MM HH:mm (Ex: 16/12, 13:11)
 */
export function formatDateTimeShort(
  date: Date | string | number | null
): string {
  const validDate = getValidDate(date);
  if (!validDate) {
    return EMPTY_VALUE_PLACEHOLDER;
  }

  return dateTimeShortFormatter.format(validDate);
}
